import React from 'react';
import {Dropdown, Tag} from 'antd';
import {Check, ChevronsUpDown} from 'lucide-react';
import './ProfileCompanySwitcher.scss';

const ProfileCompanySwitcher = ({companies = [], selectedCompanyInn, onSelect}) => {
    if (companies.length <= 1) {
        return null;
    }

    const selectedCompany = companies.find(company => company.inn === selectedCompanyInn) || companies[0];

    const companyMenuItems = companies.map(company => ({
        key: company.inn,
        label: (
            <button
                className="profile-company-option"
                type="button"
                onClick={() => onSelect(company)}
            >
                <span className="profile-company-option__name">{company.companyName || '-'}</span>
                <span className="profile-company-option__inn">{company.inn}</span>
                {selectedCompany.inn === company.inn ? <Check size={15}/> : null}
            </button>
        ),
    }));

    return (
        <Dropdown
            menu={{items: companyMenuItems}}
            trigger={['click']}
            placement="bottomRight"
        >
            <div className="profile-company-switcher profile-company-switcher--clickable">
                <span className="profile-company-switcher__meta">
                    <span className="profile-company-switcher__label">{selectedCompany.companyName || '-'}</span>
                    <span className="profile-company-switcher__sub-meta">
                        <span className="profile-company-switcher__inn">{selectedCompany.inn || '-'}</span>
                        <Tag color="success" className="profile-company-switcher__hint" style={{borderRadius: 14}}>Active company</Tag>
                    </span>
                </span>
                <span className="profile-company-switcher__button">
                    <ChevronsUpDown size={16}/>
                </span>
            </div>
        </Dropdown>
    );
};

export default ProfileCompanySwitcher;
